export default import.meta.ROLLDOWN_FILE_URL_f7oZeIWQPQZQSX6yiI5xQw